import { FREE_FORECAST_DAYS } from '../helpers/forecastHorizon';

export const NUMBER_OF_DAYS_TO_REQUEST = FREE_FORECAST_DAYS;
